export type Coloring<T> = (item: T) => number | undefined;

export function coloring<T>(items: T[], key: (item: T) => number[]): Coloring<T> {
  const groups: Record<number, T[]> = {};
  for (const item of items) {
    for (const group of key(item)) {
      groups[group] ??= [];
      groups[group].push(item);
    }
  }
  const assignments = new Map<T, number>();
  for (const items of Object.values(groups)) {
    const used = new Set(items.filter((item) => assignments.has(item)).map((item) => assignments.get(item)!));
    let i = 0;
    for (const item of items) {
      if (assignments.has(item)) continue;
      while (used.has(i)) i += 1;
      assignments.set(item, i);
      used.add(i);
    }
  }
  return (item: T) => assignments.get(item);
}
